const isDevEnv = process.env.NODE_ENV === 'dev';

const columns = [
  {
    text: 'Aus-<br>wahl',
    align: 'start',
    sortable: false, // TODO: make it sortable so they can check all the chosen ones before sending?
    cell: 'CheckboxCell',
    columnName: 'isSelected',
    width: 50,
    displaySize: 'all',
  },
  // Decision VBZ, 15.05.24 to hide column
  // {
  //   text: 'ID',
  //   align: 'start',
  //   sortable: true,
  //   cell: 'TextCell',
  //   columnName: 'id',
  //   width: 70,
  //   displaySize: 'all', //all | mdAndDown | lgAndUp
  // },
  {
    text: 'Grund',
    align: 'start',
    sortable: true,
    cell: 'AbsenceReason',
    columnName: 'reasonId',
    width: 60,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },

  {
    text: 'zugewiesen an',
    align: 'start',
    sortable: true,
    cell: 'TextCell',
    columnName: 'assignedTo',
    width: 90,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Crew ok',
    align: 'start',
    sortable: false,
    cell: 'CheckboxCell',
    columnName: 'crewReport',
    width: 40,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Meldung Vorg.',
    align: 'start',
    sortable: false,
    cell: 'CheckboxCell',
    columnName: 'supervisorReport',
    width: 40,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'VBZ Nr.',
    align: 'start',
    sortable: true,
    cell: 'TextCell',
    columnName: 'vbzNr',
    width: 100,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Dienst',
    align: 'end',
    sortable: true,
    cell: 'DutyCellWithDetailView',
    columnName: 'duty',
    width: 130,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Dienst von - bis',
    align: 'center',
    sortable: true,
    cell: 'FromTo',
    columnName: 'fromTo',
    width: 200,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Linie/Kurs',
    align: 'center',
    sortable: true,
    cell: 'TextCell',
    columnName: 'line',
    width: 80,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  // removed on Request of VBZ
  {
    text: 'Ersatz 1',
    align: 'start',
    sortable: true,
    cell: 'TextCellEdit',
    columnName: 'backup1',
    width: 100,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  // {
  //   text: 'Ersatz 1 ok',
  //   align: 'center',
  //   sortable: true,
  //   cell: 'CheckboxCell',
  //   columnName: 'backup1_reported',
  //   width: 60,
  //   displaySize: 'all', //all | mdAndDown | lgAndUp
  // },
  {
    text: 'Ersatz 1 bis',
    align: 'start',
    sortable: true,
    cell: 'Backup1Until',
    columnName: 'backup1_until',
    width: 90,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Ersatz 2',
    align: 'center',
    sortable: false,
    cell: 'TextCellEdit',
    columnName: 'backup2',
    width: 100,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  // {
  //   text: 'Ersatz 2 ok',
  //   align: 'center',
  //   sortable: true,
  //   cell: 'CheckboxCell',
  //   columnName: 'backup2_reported',
  //   width: 80,
  //   displaySize: 'all', //all | mdAndDown | lgAndUp
  // },

  {
    text: 'Bemerkung',
    align: 'left',
    sortable: true,
    width: 200,
    cell: 'Remark',
    columnName: 'remarkId',
    displaySize: 'mdAndDown', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Bemerkung',
    align: 'left',
    sortable: true,
    width: 250,
    cell: 'Remark',
    columnName: 'remarkId',
    displaySize: 'lgAndUp', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Dauer der Abwesenheit',
    align: 'left',
    sortable: true,
    cell: 'AbsenceDuration',
    columnName: 'absenceDurationId',
    width: 140,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Bemerkung für Züri 9',
    cell: 'MultiLineTextCell',
    columnName: 'remarks',
    sortable: false,
    align: 'center',
    width: 160,
    displaySize: 'none', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Status',
    align: 'center',
    sortable: true,
    cell: 'DispoState',
    columnName: 'dispoState',
    width: 150,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Meldedatum',
    align: 'center',
    sortable: true,
    cell: 'ReportedAtTime',
    columnName: 'reportedAtTime',
    width: 100,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Erfasser',
    align: 'start',
    sortable: false,
    cell: 'TextCell',
    columnName: 'disponent',
    width: 80,
    displaySize: 'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Bearbeiter',
    align: 'start',
    sortable: false,
    cell: 'TextCell',
    columnName: 'redakteur',
    width: 80,
    displaySize: 'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Aktionen',
    cell: 'actions',
    columnName: 'actions',
    sortable: false,
    align: 'center',
    width: isDevEnv ? 150 : 120,
    displaySize: 'all', //all | mdAndDown | lgAndUp
  },

  // { text: '', columnName: 'data-table-expand' },
];

export default columns;
